module.exports = {
  SectionsContainer: require('./dist/SectionsContainer'),
  Section: require('./dist/Section'),
  Header: require('./dist/Header'),
  Footer: require('./dist/Footer'),
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/react-fullpage/0.1.1/react-fullpage/index.js
 ** module id = 1160
 ** module chunks = 0
 **/